import { useEffectiveTheme, useThemeStore } from '@/stores/theme';
import { useEffect } from 'react';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const effective = useEffectiveTheme();
  const accent = useThemeStore((s) => s.accent);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', effective === 'dark');
    root.style.colorScheme = effective;
  }, [effective]);

  // The accent is one attribute on `<html>`; `tokens.css` turns it into the
  // four brand values for the current theme (spec §32). Every consumer
  // (`bg-brand`, `text-brand-text`, `--chart-1`, the rail's current row) reads
  // those, so nothing else in the app knows a preset exists.
  useEffect(() => {
    document.documentElement.dataset.accent = accent;
  }, [accent]);

  return <>{children}</>;
}
